import { getDataIdsFromContract } from '../../../../shared/utils/dataId';

export const FLAT_FILE_OBJECT_CONFIG_DATA_IDS = getDataIdsFromContract({
  base: 'flat-file-object-config',
  shimmer: '',
  retryAlert: '',
  objectIcon: 'objects',
  footer: 'footer',
  saveAndContinue: 'save'
});
